import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useDrillViewData } from "../../hooks/useFieldEditorShared.tsx";

export default function BulkEditPerformerLabelModal({ onClose }) {
  // Get data from context hooks
  const { drill, view, engine } = useDrillViewData();
  const [bulkLabel, setBulkLabel] = useState("");
  const [bulkNumber, setBulkNumber] = useState("");
  const [performers, setPerformers] = useState([]);
  const [selectedPerformers, setSelectedPerformers] = useState([]);

  useEffect(() => {
    console.log("view", view);
    const performers = view.getDrill().performers;
    const viewEngine = view.getEngine();
    setSelectedPerformers(viewEngine.selectedPerformers);
    setPerformers(performers);
  }, [view]);


  const handleBulkLabelChange = (bulkLabel) => {
    try {

      const lastPerformer = performers.sort(
        (a, b) => b.number - a.number
      ).find((performer) => performer.symbol === bulkLabel);

      let performerNumber = lastPerformer ? lastPerformer.number : 0;

      selectedPerformers.forEach((performer, index) => {
        performer.symbol = bulkLabel;
        performer.number = performerNumber + index + 1;
      });

      toast.success(`Selected performers relabeled to ${bulkLabel}`);
      view.getEngine().clearSelection();
      // view.draw();
      view.getDrill().draw();

      onClose();
    } catch (error) {
      toast.error("Error changing labels for performers");
      console.error(error)
      onClose();
    }
  };
  return <>
    <div
      className="relative z-50"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        aria-hidden="true"
      ></div>

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto ">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm w-full min-w-[30%]">
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 w-full ">
              <button
                onClick={onClose}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >
                Close
              </button>
              <div className="sm:flex sm:items-start mt-4">
                <h3 className="text-xl font-bold">Change Symbol</h3>
              </div>

              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6"></div>
              <div className="flex-1">
                <label
                  htmlFor="labelLetter"
                  className="block text-sm font-medium text-gray-900"
                >
                  {" "}
                  Performer Label
                </label>

                <select
                  name="labelLetter"
                  id="labelLetter"
                  value={bulkLabel}
                  onChange={(e) =>
                    setBulkLabel(e.target.value.toUpperCase())
                  }
                  className="mt-1.5 w-full rounded-sm border-gray-300 text-gray-700 sm:text-sm h-10"
                >
                  <option disabled value="">
                    Please select
                  </option>
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="C">C</option>
                  <option value="D">D</option>
                  <option value="E">E</option>
                  <option value="F">F</option>
                  <option value="G">G</option>
                  <option value="H">H</option>
                  <option value="I">I</option>
                  <option value="J">J</option>
                  <option value="K">K</option>
                  <option value="L">L</option>
                  <option value="M">M</option>
                  <option value="N">N</option>
                  <option value="O">O</option>
                  <option value="P">P</option>
                  <option value="Q">Q</option>
                  <option value="R">R</option>
                  <option value="S">S</option>
                  <option value="T">T</option>
                  <option value="U">U</option>
                  <option value="V">V</option>
                  <option value="W">W</option>
                  <option value="X">X</option>
                  <option value="Y">Y</option>
                  <option value="Z">Z</option>
                </select>
              </div>
              <button
                onClick={() =>
                  handleBulkLabelChange(bulkLabel)
                }
                className="mt-4 inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500"
              >
                Change Symbol
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </>

}